import React, { type MouseEvent } from 'react'

import { Link, Button } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

import { useProject } from '../../../root/contexts/ProjectContext'

const RemoveProjectButton: React.FC<{ useLowerCase?: boolean }> = ({ useLowerCase = false }) => {
  const { t } = useLocalizations()
  const { removeProject } = useProject()

  const onRemoveClick = (e: MouseEvent) => {
    e.preventDefault()
    removeProject()
  }

  return (
    <Link
      render={(p) => (
        <Button skin="link" className={p.className} data-testid="work-remove" onClick={onRemoveClick}>
          {p.children}
        </Button>
      )}
    >
      {useLowerCase ? t('projects.remove-link').toLowerCase() : t('projects.remove-link')}
    </Link>
  )
}

export default RemoveProjectButton
